import {
	fetchUserProfile,
	fetchUserAddressList,
	fetchUserCredit,
	fetchUserPeymentToken,
} from '../../api/user';

import { fetchCompanyConfig } from '../../api/company';
// import { setHiddenPrice } from '../../helpers';

import shareData from '../../shareData';
import {
	AUTH_LOGGED_IN,
	AUTH_LOG_OUT,
	SET_AFTER_LOGIN,
	REMOVE_AFTER_LOGIN,
	UPDATE_USER_CREDIT,
	UPDATE_COMPANY_ONLINE,
	TOKEN_LOADING,
} from './actionTypes';
import { redirectToBank } from '../../../src/helpers/index';

const fetchUserData = () => {
	return new Promise((resolve, reject) => {
		Promise.all([
			fetchUserProfile(),
			fetchUserAddressList(),
			fetchUserCredit(),
			fetchCompanyConfig(),
		])
			.then(([profile, addressList, credit, company]) => {
				resolve({
					profile,
					addressList,
					credit,
					company,
				});
			})
			.catch(reject);
	});
};

export const getUserAction =
	(callback = () => {}) =>
	(dispatch) => {
		fetchUserData()
			.then(({ profile, addressList, credit, company }) => {
				if (company.showPrice === false) {
					shareData.menu.showPrice = false;
				}
				dispatch({
					type: AUTH_LOGGED_IN,
					payload: { profile, addressList, credit, company },
				});

				dispatch(removeAfterLoginAction());
				callback();
			})
			.catch(callback);
	};

export const authLogoutAction = () => ({
	type: AUTH_LOG_OUT,
	payload: true,
});

export const setAfterLoginAction = (action, name = null, data = null) => {
	return {
		type: SET_AFTER_LOGIN,
		payload: {
			action,
			name,
			data,
		},
	};
};

export const removeAfterLoginAction = () => (dispatch, getState) => {
	const { action } = getState().user.afterLogin;

	if (action) {
		dispatch({
			type: REMOVE_AFTER_LOGIN,
		});
	}
};

export const getUserCreditAction = () => (dispatch, getState) => {
	const hasCredit = getState().user.company.hasCredit;

	if (hasCredit) {
		fetchUserCredit().then((credit) => {
			dispatch({
				type: UPDATE_USER_CREDIT,
				payload: credit,
			});
		});
	}
};

export const checkCompanyOnlineAction = () => (dispatch) => {
	fetchCompanyConfig().then((company) => {
		const payload = {
			online: false,
			// online: company.online,
			offlineText: company.offlineText,
		};
		dispatch({
			type: UPDATE_COMPANY_ONLINE,
			payload,
		});
	});
};
export const getUserTokenForOnlinePayment = (id) => (dispatch) => {
	dispatch({
		type: TOKEN_LOADING,
		payload: true,
	});
	fetchUserPeymentToken(id).then((data) => {
		if (data.token) {
			// window.location.replace(`https://pec.shaparak.ir/NewIPG/?Token=${token}`);
			// dispatch({
			// 	type: TOKEN_LOADING,
			// 	payload: false,
			// });
			redirectToBank(data);
			// const hiddenField = document.createElement("input");
			// hiddenField.setAttribute("name", "Token");
			// hiddenField.setAttribute("value", token);

			// const formRaw = document.createElement("form");
			// formRaw.setAttribute("method", "POST");
			// formRaw.setAttribute(
			//   "action",
			//   "https://sep.shaparak.ir/MobilePG/MobilePayment"
			// );
			// formRaw.setAttribute("target", "_self");

			// formRaw.appendChild(hiddenField);
			// document.body.appendChild(formRaw);
			// formRaw.submit();
			// document.body.removeChild(formRaw);
		}
	});
};
